import apolloClients from '@/utils/apolloClients.js';

// endpoints
export const pns_graphal_client = apolloClients['pns'];
export const emr_graphal_client = apolloClients['emr'];
